import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_slide",
  "use": "arrow_slide-usage",
  "viewBox": "0 0 9 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 15\" id=\"arrow_slide\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.151.898c-.1.1-.151.215-.151.345 0 .13.05.244.151.344l5.94 5.886L.15 13.36a.47.47 0 0 0-.15.344c0 .13.05.245.15.345l.756.748a.48.48 0 0 0 .695 0l7.043-6.979c.1-.1.151-.215.151-.345a.47.47 0 0 0-.15-.344L1.601.15a.48.48 0 0 0-.695 0L.15.9z\" fill=\"#626469\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol